export const title = 'Nowoczesna geodezja,'
export const subtitle = 'indywidualne podejście!'
